import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../common/Navbar";
import "../../styles/courses.css";
import courses_img1 from "../../assets/images/webp/courses_img1.jpg";
import courses_img2 from "../../assets/images/webp/courses_img2.jpg";
import courses_img3 from "../../assets/images/webp/courses_img3.jpg";
import courses_img4 from "../../assets/images/webp/courses_img4.jpg";
import courses_img5 from "../../assets/images/webp/courses_img5.jpg";
import courses_img6 from "../../assets/images/webp/courses_img6.jpg";
import courses_img7 from "../../assets/images/webp/courses_img7.jpg";
import courses_img8 from "../../assets/images/webp/courses_img8.jpg";
import courses_img9 from "../../assets/images/webp/courses_img9.jpg";
import courses_img10 from "../../assets/images/webp/courses_img10.jpg";
import courses_img11 from "../../assets/images/webp/courses_img11.jpg";
import courses_img12 from "../../assets/images/webp/courses_img12.jpg";
import courses_img13 from "../../assets/images/webp/courses_img13.jpg";
import courses_img14 from "../../assets/images/webp/courses_img14.jpg";
import courses_img15 from "../../assets/images/webp/courses_img15.jpg";
import courses_img16 from "../../assets/images/webp/courses_img16.jpg";
import courses_img17 from "../../assets/images/webp/courses_img17.jpg";
import courses_img18 from "../../assets/images/webp/courses_img18.jpg";
import courses_img19 from "../../assets/images/webp/courses_img19.jpg";
import courses_img20 from "../../assets/images/webp/courses_img20.jpg";
import courses_img21 from "../../assets/images/webp/courses_img21.jpg";

const COURSES = [
  {
    img: courses_img1,
    title: "Animation Director",
    desc: "Master the art of overseeing animation projects, from concept to completion, ensuring a seamless blend of creativity and technology. Train with us to become an Animation Director and lead groundbreaking projects in the animation world.",
  },
  {
    img: courses_img2,
    title: "AR/VR Developer",
    desc: "Build advanced augmented and virtual reality applications, focusing on programming and interactive user experiences. Join our course to become an AR/VR Developer and engineer the future of immersive media.",
  },
  {
    img: courses_img3,
    title: "AR/VR Producer",
    desc: "Manage the development of AR and VR projects, coordinating teams and ensuring creative and technical excellence. Train with us to become an AR/VR Producer and shape the future of interactive storytelling.",
  },
  {
    img: courses_img4,
    title: "Art Director (Animation & Gaming)",
    desc: "Define the artistic vision for animation and gaming projects, creating a cohesive visual experience. Become an Art Director and inspire teams to craft stunning content.",
  },
  {
    img: courses_img5,
    title: "Cinematographer/Videographer",
    desc: "Capture captivating visuals with expertise in camera operation, lighting, and composition. Train to become a Cinematographer/Videographer and tell stories through your lens.",
  },
  {
    img: courses_img6,
    title: "Community Journalist",
    desc: "Report on local issues and stories, engaging communities and driving impactful journalism. Join us to become a Community Journalist and shine as a voice for the people.",
  },
  {
    img: courses_img7,
    title: "Content Strategist",
    desc: "Develop strategies for impactful content creation, delivery, and management. Become a Content Strategist and lead businesses in crafting narratives that engage audiences.",
  },
  {
    img: courses_img8,
    title: "Digital Marketing Manager",
    desc: "Master digital campaigns, SEO, social media, and analytics to drive online success. Train with us to become a Digital Marketing Manager and revolutionize brand presence.",
  },
  {
    img: courses_img9,
    title: "Director of Photography",
    desc: "Shape cinematic narratives through expert camera work, lighting, and visual storytelling. Enroll to become a Director of Photography and craft masterpieces for screens big and small.",
  },
  {
    img: courses_img10,
    title: "Game Artist",
    desc: "Create compelling visuals for games, including character design and environments. Become a Game Artist and bring imaginative worlds to life.",
  },
  {
    img: courses_img11,
    title: "Graphic Designer",
    desc: "Learn design principles, software, and creative communication to craft stunning visuals. Train with us to become a Graphic Designer and transform ideas into impactful designs.",
  },
  {
    img: courses_img12,
    title: "Multiplex Operation Manager",
    desc: "Manage cinema operations, focusing on customer experience and operational efficiency. Join us to become a Multiplex Operation Manager and lead the entertainment experience.",
  },
  {
    img: courses_img13,
    title: "Music Producer",
    desc: "Craft and oversee music production, from recording to final composition. Train to become a Music Producer and orchestrate melodies that resonate.",
  },
  {
    img: courses_img14,
    title: "Rendering Artist",
    desc: "Turn 3D models into stunning visuals with expertise in lighting, shading, and texturing. Become a Rendering Artist and bring digital creations to life.",
  },
  {
    img: courses_img15,
    title: "Rigging Artist",
    desc: "Create skeletal structures for 3D models, enabling lifelike movements in animations. Train with us to become a Rigging Artist and breathe life into characters.",
  },
  {
    img: courses_img16,
    title: "Sales Director",
    desc: "Lead sales strategies and teams to drive growth and success. Become a Sales Director and spearhead transformative business achievements.",
  },
  {
    img: courses_img17,
    title: "Script Writer",
    desc: "Craft captivating scripts for film, TV, and digital platforms, mastering storytelling and dialogue. Train to become a Script Writer and shape narratives that captivate audiences.",
  },
  {
    img: courses_img18,
    title: "Search Engine Marketing Executive",
    desc: "Execute impactful paid search campaigns to boost visibility and drive traffic. Become a SEM Executive and lead brands to top search rankings.",
  },
  {
    img: courses_img19,
    title: "Search Engine Optimization Executive",
    desc: "Optimize websites for higher rankings with keyword strategies, backlinks, and analytics. Join us to become an SEO Executive and amplify online presence.",
  },
  {
    img: courses_img20,
    title: "Social Media Manager",
    desc: "Plan and manage social media campaigns, engaging communities and driving brand awareness. Train with us to become a Social Media Manager and make waves in the digital sphere.",
  },
  {
    img: courses_img21,
    title: "Sound Designer",
    desc: "Create immersive soundscapes for films, games, and media productions. Train to become a Sound Designer and enhance auditory experiences that captivate.",
  },
];

const TITLE = "Our Courses";

const CourseHeroSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="crs">
      <Navbar />

      {/* ============ HERO ============ */}
      <section className="crs-hero">
        <span className="crs-hero-watermark" aria-hidden="true">
          Courses
        </span>
        <div className="crs-glow crs-glow--red" />
        <div className="crs-glow crs-glow--navy" />

        <div className="container position-relative z-1 text-center">
          <p className="crs-eyebrow">
            <span className="crs-eyebrow-dot" />
            HKI Media Skilling
          </p>

          <h1 className="crs-title">
            {TITLE.split(" ").map((word, i, arr) => (
              <span
                key={word + i}
                className={`crs-title-word ${
                  i === arr.length - 1 ? "section-heading-accent" : ""
                }`}
                style={{ animationDelay: `${i * 0.12 + 0.1}s` }}
              >
                {word}&nbsp;
              </span>
            ))}
          </h1>

          <p className="crs-subtitle">
            Career track programs across animation, AR/VR, media, and
            marketing, built to take you from training to a working role.
          </p>
        </div>
      </section>

      {/* ============ COURSE GRID ============ */}
      <section className="crs-grid-section">
        <div className="container">
          <div className="crs-grid">
            {COURSES.map((course, idx) => (
              <article
                className="crs-card"
                key={course.title}
                data-aos="fade-up"
                data-aos-delay={(idx % 3) * 90}
              >
                <div className="crs-card-img-wrap">
                  <img
                    src={course.img}
                    alt={course.title}
                    className="crs-card-img"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="crs-card-body">
                  <h3>{course.title}</h3>
                  <p>{course.desc}</p>
                  <Link to="/contact-us" className="crs-card-cta">
                    Inquire Now <span aria-hidden="true">&rarr;</span>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ============ CLOSING CTA ============ */}
      <section className="crs-cta">
        <div className="crs-glow crs-glow--cta" />
        <div className="container position-relative z-1 text-center" data-aos="zoom-in">
          <p className="crs-cta-text">
            Not sure which course fits you best? Talk to our admissions team
            and find your path.
          </p>
          <Link to="/contact-us" className="crs-btn crs-btn--light">
            Talk to Admissions
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CourseHeroSection;
